import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { isChunkLoadError, reloadOnceForStaleAssets } from './app/core/utils/chunk-load.util';

// Request notification permissions for session warnings
if ('Notification' in window && Notification.permission === 'default') {
  Notification.requestPermission();
}

function recoverFromStartupFailure(error: unknown): void {
  console.error('Global error:', error);
  if (isChunkLoadError(error)) {
    reloadOnceForStaleAssets();
  }
}

window.addEventListener('error', (event) => {
  recoverFromStartupFailure(event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromStartupFailure(event.reason);
});

// Bootstrap with error handling
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('Failed to bootstrap application:', err);
    if (isChunkLoadError(err) && reloadOnceForStaleAssets()) {
      return;
    }
    // Show user-friendly error message
    document.body.innerHTML = `
      <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: Arial, sans-serif;">
        <div style="text-align: center; padding: 20px;">
          <h2>Application Error</h2>
          <p>The application failed to start. Please refresh the page or contact support.</p>
          <button onclick="window.location.reload()" style="padding: 10px 20px; margin: 10px; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      </div>
    `;
  });
